// Auto-generated from package.json. Do not edit.
export const SDK_VERSION = '2.0.5'
